
(function ($) { 
    
    Drupal.behaviors.artistGallery = {

        attach: function (context) {
            Drupal.behaviors.functions.consolog("drupal init artistGallery");

            $(".artistGallery", context).each(function (index){   

                //init only in deeplink to profile
                if($(".virtualMuseum").length == 0 && $(".artistResidenceHeader").length == 0){

                    $(this).removeClass("pageview");
                    $(this).removeClass("main-content-offset");
                    $(this).addClass("pageview");
                    $(this).addClass("main-content-offset");

                    //init slider
                    Drupal.behaviors.artistGallery.artistGalleryInitSlider();

                    //hide close button
                    $(".artistGalleryClosebutton").hide();
                }

            });
        }
    };

    Drupal.behaviors.artistGallery.artistGalleryInitSlider = function (context) {

        Drupal.behaviors.functions.consolog("artistGalleryInitSlider()");

        $(".artistGallery", context).each(function (index){             
            
            Drupal.behaviors.artistGallery.initSlider();

        });
    }

    Drupal.behaviors.artistGallery.initSlider = function() {

        Drupal.behaviors.functions.consolog("Drupal.behaviors.artistGallery.initSlider()");

        //detail image reset
        $(".artistGalleryDetailImage").hide();
        $(".artistGalleryDetailImage").css("opacity", 0);
        $(".artistGalleryDetailImage").find("iframe").attr("src", "");
        $(".artistGalleryDetailImage").find("img").attr("src", "");
        //$(".artistGalleryImageSliderPage").removeClass("showVideo");


        //slider events
        $('.artistGalleryImageSlider').on('init', function(slick){                       
            
            //first image title
            var firstimage = $(".artistGalleryImageSliderPage").not(".slick-cloned").first().find(".artistGalleryImage");
            var title = firstimage.attr("data-title");
            $(".artistGalleryTitle").html(title);

            Drupal.behaviors.functions.consolog("slick init! firstimage:" + firstimage.children("img").attr("src")); 
            if(firstimage.children("img")[0].complete){
                Drupal.behaviors.functions.consolog("Drupal.behaviors.artistGallery.initSlider() first image loaded (A)!");
                Drupal.behaviors.artistGallery.handleSliderResize();
            }
            else{
                firstimage.children("img").one("load", function(){
                    Drupal.behaviors.functions.consolog("Drupal.behaviors.artistGallery.initSlider() first image loaded! (B)");
                    Drupal.behaviors.artistGallery.handleSliderResize();
                });
            }

            //display page numbers
            var lng = $(this).find(".slick-slide").not($(".slick-cloned")).length;
            if(lng < 2){
                $(".artistGalleryNavigation").children(".artistGalleryNavigationIcon").hide();
            }
            else{
                $(".artistGalleryNavigation").children(".artistGalleryNavigationIcon").show();
                $(".artistGalleryNavigationLabel").html("1/" + lng);
            }
            
            $(".artistGalleryNavigation").show();

            //Drupal.behaviors.artistGallery.handleSliderResize();  

            $(".artistGalleryImageSliderPage").each(function(){
                
                if($(this).find(".artistGalleryVideoLinkContainer").length > 0){
                    var imgwidth = $(this).find(".artistGalleryVideoLinkContainer").siblings("img").width();
                    $(this).find(".artistGalleryVideoLinkContainer").css("max-width", imgwidth + "px");
                    
                    //add src to iframe
                    $(this).find(".artistGalleryVideoLinkContainer").siblings("iframe").each(function(){
						var iframeSrc = $(this).attr("data-src");
						$(this).attr("src", iframeSrc);
					});
                }
                
                //slider image click listener
                $(this).find(".artistGalleryImage").click(function(){

                    $(".preloader").show();
                    $(".artistGalleryDetailImageClosebutton").removeClass("hasVideo");
                    $(".artistGalleryDetailImage").find("img").attr("src", "");

                    if($(this).hasClass("hasVideo")){

                        var iframeSrc = $(this).children("iframe").attr("data-src");

                        if($(window).width() <= 767){
                            $(this).show();
                            $(this).children("iframe").attr("src", iframeSrc);
                            $(".preloader").hide();
                        }
                        else{
                            $(this).closest(".artistGalleryImageSliderPage").removeClass("showVideo");
                            $(this).closest(".artistGalleryImageSliderPage").addClass("showVideo");
                            
                            $(".artistGalleryDetailImage").find("iframe").attr("src", iframeSrc);
                                                    
                            $(".artistGalleryDetailImage").find("img").hide();

                            $(".artistGalleryDetailImageVideo").find("iframe").show();
                            $(".artistGalleryDetailImageVideo").show();

                            $(".artistGalleryDetailImage").css("opacity", 1);
                            $(".artistGalleryDetailImage").show();
                            $(".preloader").hide();
                            
                            $(".artistGalleryDetailImageClosebutton").addClass("hasVideo");
                        }
                    }
                    else{

                        $(".artistGalleryDetailImageVideo").hide();
                        $(".artistGalleryDetailImageVideo").find("iframe").hide();
                        
                        if($(this).hasClass("fullScreenBehavior")){
                            $(".preloader").hide();
                        }
                        else{
							
                            $(".artistGalleryDetailImage").find("img").show();
                            $(".artistGalleryDetailImage").find("img").attr("src", $(this).attr("data-image"));
                            $(".artistGalleryDetailImage").find("img").one("load", function() {
                                $(".artistGalleryDetailImage").fadeTo(500, 1, function() {
                                    $(".preloader").hide();
                                });
        
                                $(".preloader").hide();
								
								//new behaviour 2022
								if($(window).width() > _breakpointMedium){
									var magnifying_area =  document.getElementsByClassName("artistGalleryDetailImageImage")[0];
									if(magnifying_area){
										
										var magnifying_img =  magnifying_area.getElementsByTagName("img")[0];
									
										if(magnifying_img){
											//console.log("maginfying...");

											//add red bg
											$(".artistGalleryDetailImage").removeClass("colored-bg");
											$(".artistGalleryDetailImage").addClass("colored-bg");

											//scale image
											magnifying_img.style.transform = 'translate(-50%,-50%) scale(2)'
											
											//handle mousemove
											magnifying_area.addEventListener("mousemove",function(event){

												$(".artistGalleryDetailImage").removeClass("colored-bg");
												$(".artistGalleryDetailImage").addClass("colored-bg");
												
												var viewportOffset = magnifying_area.getBoundingClientRect();
												var offsetTop = viewportOffset.top;
												var offsetLeft = viewportOffset.left;

												clientX = event.clientX - offsetLeft;
												clientY = event.clientY - offsetTop;
												
												//console.log("maginfying... offsetLeft:" + offsetLeft);
												//console.log("maginfying... offsetTop:" + offsetTop);
												//console.log("maginfying... mouse-x:" + event.clientX + " mouse-y:" + event.clientY);
												//console.log("maginfying... 1. => x:" + clientX + " y:" + clientY);
												
												var mWidth = magnifying_area.offsetWidth;
												var mHeight = magnifying_area.offsetHeight;
												clientX = clientX / mWidth * 100;
												clientY = clientY / mHeight * 100;

												//console.log("maginfying... 2. => x:" + clientX + " y:" + clientY);
												
												magnifying_img.style.transform = 'translate(-'+clientX+'%, -'+clientY+'%) scale(2)';
												//console.log("maginfying... => img:" + magnifying_img.getAttribute("src"));
											});
											
											//handle mouseleave
											magnifying_area.addEventListener("mouseleave",function(){
												magnifying_img.style.transform = 'translate(-50%,-50%) scale(1)';
												//console.log("maginfying... mouseleave => img:" + magnifying_img.getAttribute("src"));
												//$(".artistGalleryDetailImage").removeClass("colored-bg");
											});
										}
									
									}
								}
                            });							
                        }
                    }

                    $(".artistGalleryDetailImage").unbind().click(function(){
                        $(".preloader").hide();

                        $(".artistGalleryDetailImage").fadeTo(500, 0, function() {                            
                            $(".artistGalleryDetailImage").hide();
                            $(".artistGalleryDetailImage").css("opacity", 0);
                            $(".artistGalleryDetailImage").find("iframe").attr("src", "");
                            $(".artistGalleryDetailImage").find("img").attr("src", "");
                            
                            //$(".artistGalleryImageSliderPage").removeClass("showVideo");
                            $(".preloader").hide();
                        });
                    });

                });
            });
        });
        $('.artistGalleryImageSlider').on('beforeChange', function(event, slick, currentSlide, nextSlide){                    
            Drupal.behaviors.functions.consolog("slick beforeChange");
            Drupal.behaviors.artistGallery.handleSliderResize();
            var lng = $(this).find(".slick-slide").not($(".slick-cloned")).length;
            $(".artistGalleryNavigationLabel").html(nextSlide+1 + "/" + lng);            

            if($(".slick-current").find("iframe").length > 0){
                
                //remove src on iframe
                $(".slick-current").find("iframe").attr("src", "");                
                
                //$(".slick-current").removeClass("showVideo");
                
                //$(".artistGalleryImageVideoIframe").attr("src", "");
                //$(".artistGalleryImageVideoIframe").hide();
            }
        });
        $('.artistGalleryImageSlider').on('afterChange', function(event, slick, currentSlide){                    
            Drupal.behaviors.functions.consolog("slick afterChange");
            $(".artistGalleryTitle").html("image title");

            var title = $(".artistGalleryImageSliderPage").not(".slick-cloned").eq(currentSlide).find(".artistGalleryImage").attr("data-title");
            $(".artistGalleryTitle").html(title);

            if($(this).find(".artistGalleryVideoLinkContainer").length > 0){
                var imgwidth = $(this).find(".artistGalleryVideoLinkContainer").siblings("img").width();
                $(this).find(".artistGalleryVideoLinkContainer").css("max-width", imgwidth + "px");

                //add src to iframe
                var iframeSrc = $(this).find(".artistGalleryVideoLinkContainer").siblings("iframe").attr("data-src");
				$(this).find(".artistGalleryVideoLinkContainer").siblings("iframe").attr("src", iframeSrc);
				
				//add src to iframe
				$(this).find(".artistGalleryVideoLinkContainer").each(function(){

					$(this).siblings("iframe").each(function(){
						var iframeSrc = $(this).attr("data-src");
						$(this).attr("src", iframeSrc);
					});
				})
            }
        });

        //slider init
        $(".artistGalleryImageSlider").slick({                    
            infinite: true,
            variableWidth: false,
            adaptiveHeight: false,
            arrows: false            
        });

        //slider buttons
        $(".artistGalleryNavigationIcon.arrowLeft").click(function(){
            $('.artistGalleryImageSlider').slick('slickPrev');
        });
        $(".artistGalleryNavigationIcon.arrowRight").click(function(){
            $('.artistGalleryImageSlider').slick('slickNext');
        });                

        $(window).resize(Drupal.behaviors.artistGallery.handleSliderResize);
    }
        

    Drupal.behaviors.artistGallery.updateSlider = function() {
        Drupal.behaviors.functions.consolog("Drupal.behaviors.artistGallery.updateSlider()");
        $('.artistGalleryImageSlider')[0].slick.refresh();
    }

    Drupal.behaviors.artistGallery.handleSliderResize = function() {

        Drupal.behaviors.functions.consolog("Drupal.behaviors.artistGallery.handleSliderResize()");
        
        var showSlider = true;

        $(".artistGalleryImageSliderPage").each(function(){
            
            var $textContainer = $(this).children(".artistGalleryText");
            var $imgContainer = $(this).children(".artistGalleryImage");

            var $img = $imgContainer.children("img");
            
            if($(window).width() > _breakpointLarge){
                //Drupal.behaviors.functions.consolog("...size calculation...");

                $textContainer.css("width", Math.floor(0.1666 * $(this).width()));
                $imgContainer.css("width", Math.floor(0.666 * $(this).width()));
                $textContainer.children().css("max-width", "none");

                if($img.width() < $imgContainer.width()){
                    $imgContainer.css("width", $img.width());
                    $textContainer.css("width", Math.floor( ($(this).width()-$img.width())/2));

                    $textContainer.children().css("max-width", Math.floor(0.1666 * $(this).width()));
                }                        
            }
            else{
                $textContainer.css("width", "100%");
                $imgContainer.css("width", "100%");
                $textContainer.children().css("max-width", "none");
            }

            if($(this).find(".artistGalleryVideoLinkContainer").length > 0){
                var imgwidth = $(this).find(".artistGalleryVideoLinkContainer").siblings("img").width();
                $(this).find(".artistGalleryVideoLinkContainer").css("max-width", imgwidth + "px");
            }
            
            /*
            if($(this).height() < $(this).parent(".slick-track").height()){
                var mt = ($(this).parent(".slick-track").height() - $(this).height()) / 2;
                $(this).css("margin-top", mt+"px");
            }
            */
        });

        $(".artistGallery").each(function(){
            
            $(this).find(".artistGalleryContent").css("margin-top", 0);
            var h = $(this).height() - $(this).find(".artistGalleryTitle").outerHeight(true) - $(this).find(".artistGalleryFooter").outerHeight(true);
            
            var mt = 0;
            if(h > 0){
                mt = Math.round((h - $(".artistGalleryContent").outerHeight(true))/2);                
            }
            
            if(mt > 0){
                $(this).find(".artistGalleryContent").css("margin-top", mt + "px");
            }
            else{
                var ie = Drupal.behaviors.functions.detectIE();  
                if(ie && ie <= 11){
                    showSlider = false;
                    setTimeout(function(){
                        Drupal.behaviors.artistGallery.handleSliderResize();
                    }, 500);
                }
            }

            Drupal.behaviors.functions.consolog("### set artistGalleryContent margin to " + mt);

        });    
        
        if(showSlider){
            $(".artistGalleryImageSlider").css("opacity", 1);
        }
    }
    
})(jQuery);
